export default __webpack_public_path__ + "static/media/i (23).6b72031b.jpg";